import react, {useRef, useState, useEffect} from 'react';
import {Row, Card, Col, Empty, Pagination, message, Spin, Tooltip, Drawer, Button, Modal} from 'antd';
import styles from './index.module.less';
import {ModalBindingKuklerSchemesDetailsModelDom} from './bindingKuklerSchemeDetailsModel';
import {kjlAccountFn} from './components/kjlAccountModal.tsx';
import dayjs from "dayjs";
import {SBack, SDrawerOrModal, SMessage, SSearchForm} from "shj-components";
import {
  dcpBizOpDesignRelListBizOpDesignInfo,
  dcpDesignInfoSave,
  dcpDesignInfoSave2,
  searchSelfDesignInfo
} from "@/services/kuAccount.ts";
import _ from "lodash-es";
import {useParams} from "react-router-dom";

export const KjlManagerCopy = (props: any) => {
  const id = useParams()?.id || props?.bizId;
  const searchForm = useRef<any>();
  const [searchData, setSearchData] = useState<any>({...searchForm?.current?.getFieldsValue()}); //搜索
  const [kjlSchemesList, setKjlSchemesList] = useState<any>([]); //酷家乐方案列表
  const [pagination, setPagination] = useState<any>({
    total: 0,
    current: 1,
    pageSize: 10,
  }); //分页
  const [loading, setLoading] = useState<any>(false); //分页
  // 获取基础数据
  const [confirmLoading, setConfirmLoading] = useState<any>(false); //提交
  // 获取基础数据
  const [visibleDrawer, setVisibleDrawer] = useState<any>(false); //抽屉
  const [bindedObj, setBindedObj] = useState<any>({}); //已绑定方案对象
  // 获取基础数据
  const [nowDetails, setNowDetails] = useState<any>({}); //当前详情
  // 获取基础数据
  const initFn = (pageData: any) => {
    const {current, pageSize} = pageData;
    const query = searchForm?.current?.getFieldsValue();
    console.log(query, 111)
    setLoading(true);
    searchSelfDesignInfo({...query, current, pageSize})
      .then((data: any) => {
        const records = _.get(data, 'list', []);
        const total = _.get(data, 'count', 0);
        setKjlSchemesList(records);
        setPagination({
          ...pagination,
          ...pageData,
          total,
        });
        setLoading(false);
      })
      .catch(() => {
        setKjlSchemesList([]);
        setPagination({
          total: 0,
          current: 1,
          pageSize: 10,
        });
        setLoading(false);
      });
  };
  // 已绑定
  const bindedFn = () => {
    if (!id) return;
    dcpBizOpDesignRelListBizOpDesignInfo([id])
      .then((resp: any) => {
        const data = resp?.[id] || {};
        setBindedObj({
          ...data,
        });
      })
      .catch(() => {
        setBindedObj({});
      });
  };
  // 搜索
  const onSearchFinish = (value: any) => {
    setSearchData(value);
    setPagination({
      total: 0,
      current: 1,
      pageSize: 10,
    });
    initFn({
      total: 0,
      current: 1,
      pageSize: 10,
    });
    bindedFn();
  };
  // 重置
  const onSearchReset = () => {
    setSearchData({});
    initFn({
      total: 0,
      current: 1,
      pageSize: 10,
    })
  };
  // 已绑定
  const bindDom = () => {
    return Object.keys(bindedObj).length > 0 ? (
        <Card size="small" bordered={false} bodyStyle={{padding: '0 0 10px 0'}}>
          <div className={styles.boundBox}>
            <div className={styles.leftBox}>已绑定方案</div>
            <div
                className={styles.rightBox}
                onClick={() => {
                  setNowDetails({...bindedObj});
                  setVisibleDrawer(true);
                }}
            >
              <div className={styles.imgBox}>
                <img src={bindedObj.planPic || bindedObj.designPanoUrl} alt={''}/>
                <span className={styles.txt1}>{bindedObj.status == 1 ? '装修阶段' : '户型阶段'}</span>
              </div>
              <div className={styles.imgTxt}>
                <Tooltip title={`${bindedObj.name}`}>
                  <div className={styles.txt1}>{bindedObj.name}</div>
                </Tooltip>
                <div className={styles.txt2}>{bindedObj.commName}</div>
                <div className={styles.txt3}>
                  <span>{bindedObj.planId ? '户型ID' : '方案ID'}</span>
                  {bindedObj.planId || bindedObj.designId}
                </div>
                <div className={styles.txt4}>
                  绑定时间：{bindedObj?.createdTime ? dayjs(bindedObj.createdTime).format('YYYY-MM-DD HH:mm:ss') : ''}
                </div>
              </div>
            </div>
          </div>
        </Card>
    ) : null;
  };
  // 方案列表
  const schemeListDom = () => {
    return kjlSchemesList?.length > 0 ? (
        <Card size="small" bordered={false} bodyStyle={{padding: '0 0 10px 0'}}>
          <div className={styles.schemeListBox}>
            <Spin spinning={loading} style={{color: '#666'}}>
              <Row gutter={[12, 12]}>
                {kjlSchemesList.map((item: any, index: number) => {
                  return (
                      <Col span={6} key={`${item.planId}-${item.designId}-${index}`}>
                        <div
                            className={styles.schemeItemBox}
                            onClick={() => {
                              setNowDetails({...item});
                              setVisibleDrawer(true);
                            }}
                        >
                          <div className={styles.imgBox}>
                            <img src={item.coverPic} alt={''}/>
                            {/*<div className={styles.txt1}>{item.status == 1 ? '装修阶段' : '户型阶段'}</div>*/}
                            {/*<div className={styles.txt2}>取消</div>*/}
                            <div className={styles.txt2}>选择</div>
                          </div>
                          <div className={styles.imgTxt}>
                            <Tooltip title={`${item.name}`}>
                              <div className={styles.txt1}>{item.name}</div>
                            </Tooltip>
                            <div className={styles.txt2}>{item.commName}</div>
                            <div className={styles.txt3}>
                              <span>{bindedObj.planId ? '户型ID' : '方案ID'}</span>
                              {bindedObj.planId || bindedObj.designId}
                            </div>
                          </div>
                        </div>
                      </Col>
                  );
                })}
              </Row>
              <div className={styles.paginationBox}>
                <Pagination
                    key="key"
                    size="small"
                    showSizeChanger
                    showQuickJumper
                    showTotal={() => `${pagination.total}条`}
                    current={pagination.current}
                    pageSize={pagination.pageSize}
                    defaultCurrent={1}
                    defaultPageSize={10}
                    hideOnSinglePage={false}
                    total={pagination.total}
                    onChange={(page, pageSize) => {
                      setPagination({
                        ...pagination,
                        current: page,
                        pageSize,
                      });
                      initFn({current: page, pageSize});
                    }}
                />
              </div>
            </Spin>
          </div>
        </Card>
    ) : <Spin spinning={false} style={{color: '#666'}}>
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
      <div className={styles.paginationBox}>
        <Pagination
            key="key"
            showSizeChanger
            showQuickJumper
            showTotal={() => `${pagination.total}条`}
            current={pagination.current}
            pageSize={pagination.pageSize}
            defaultCurrent={1}
            defaultPageSize={10}
            hideOnSinglePage={false}
            total={pagination.total}
            onChange={(page, pageSize) => {
              setPagination({
                ...pagination,
                current: page,
                pageSize,
              });
              initFn({current: page, pageSize});
            }}
        />
      </div>
    </Spin>;
  };

  // 方案详情
  const onCloseFn = () => {
    setVisibleDrawer(false);
  };
  // 绑定方案
  const onConfirmFn = () => {
    SMessage.confirm({
      title: `是否复制当前方案？`,
      content: null,
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        kjlAccountFn({
          source: 'copy',
          fn: (appuid: any) => {
            const {designId} = nowDetails;
            const submitObj: any = {
              bizOpId: id,
              designId,
              appUid: appuid,
            };
            setConfirmLoading(true);
            return new Promise((resolve, reject) => {
              dcpDesignInfoSave(submitObj)
                  .then((data: any) => {
                    bindedFn();
                    setVisibleDrawer(false);
                    setConfirmLoading(false);
                    message.success( '操作成功');
                    resolve()
                  })
                  .catch(() => {
                    setVisibleDrawer(false);
                    setConfirmLoading(false);
                    reject()
                  });
            })
          },
        });
      },
    });
  };
  useEffect(() => {
    initFn(pagination);
    return () => {
    };
  }, []);

  useEffect(() => {
    bindedFn();
  }, [id]);

  const onCopyByPerson = () => {
    kjlAccountFn({
      source: 'copy',
      fromPerson: true,
      fn: (appuid: any, designId: any) => {
        const submitObj: any = {
          bizOpId: id,
          designId: designId,
          appUid: appuid,
        };
        setConfirmLoading(true);
        return new Promise((resolve, reject) => {
          dcpDesignInfoSave2(submitObj)
              .then((data: any) => {
                bindedFn();
                setVisibleDrawer(false);
                setConfirmLoading(false);
                message.success(data?.message ? data?.message : '复制成功');
                resolve()
              })
              .catch(() => {
                setVisibleDrawer(false);
                setConfirmLoading(false);
                reject()
              });
        })
      },
    });
  };

  return (
      <SBack level={2} title={'复制已有方案绑定'}>
        <Card size="small" bordered={false} className={styles.mt10}>
          <SSearchForm
              searchMode={'group'}
              fieldControl={false}
              onFinish={onSearchFinish}
              onReset={onSearchReset}
              formRef={searchForm}
              initialValues={{}}
              columns={[
                {name: 'name', label: '客户姓名'},
                {name: 'bizOpId', label: '商机ID'},
              ]}
          />
        </Card>
        <Card
            title={
              <>
                <div className={styles.title}>数据列表</div>
              </>
            }
            extra={<Button
                className={'ant-btn szyxy-btn'}
                onClick={() => {
                  onCopyByPerson();
                }}
                style={{margin: 10}}
                type={'primary'}
            >
              从酷家乐个人账号复制
            </Button>}
            bordered={false}
            bodyStyle={{padding: 10}}
        >
          {/*已绑定*/}
          {bindDom()}
          {/*方案列表*/}
          {schemeListDom()}
        </Card>
        <SDrawerOrModal
            bodyStyle={{padding: 10}}
            title="方案详情"
            onCancel={onCloseFn}
            open={visibleDrawer}
            loading={confirmLoading}
            onOk={onConfirmFn}
            okText={'复制'}
            antdProps={{
              [nowDetails?.id ? 'footer' : '']: null
            }}
        >
          <div>
            <ModalBindingKuklerSchemesDetailsModelDom nowDetails={nowDetails}/>
          </div>
        </SDrawerOrModal>
      </SBack>
  );
};

export default (props: any) => {
  return <KjlManagerCopy {...props} />;
};
